//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShareIcon from '~/static/share.svg?inline';

export default {
  components: {
    ShareIcon,
  },

  props: {
    buttonText: {
      type: String,
      required: false,
      default: 'Copy link',
    },
    labelText: {
      type: String,
      required: false,
      default: 'Copy link',
    },
    shareButtonText: {
      type: String,
      default: 'Share',
    },
    shareableText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    buttonClass: {
      type: String,
      required: false,
      default: '',
    },
    iconClass: {
      type: String,
      required: false,
      default: '',
    },
    wrapperClass: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      showModal: false,
      modalClass: this.wrapperClass ? 'share-modal'.concat(' ', this.wrapperClass) : 'share-modal',
    };
  },

  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },

    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.shareableText);
        this.$toastr.s('Copied!');
      } catch (e) {
        // navigator doesn't exist, copy hidden elem
        // This is just for local envs, as navigator only works on https/localhost
        this.documentCopyToClipboard();
      }
    },

    documentCopyToClipboard() {
      const el = document.createElement('textarea');

      try {
        el.value = this.shareableText;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';

        document.body.appendChild(el);

        const selected = document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0) : false;

        el.select();
        document.execCommand('copy');

        this.$toastr.s('Copied!');
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
      } catch (e) {
        // failed to copy the created element
      } finally {
        document.body.removeChild(el);
      }
    },
  },
};
